import { useEffect } from 'react';
import { useSiteSettings } from '../context/SiteSettingsContext';
import { useLanguage } from '../context/LanguageContext';

/**
 * Dynamic meta tags component for SEO and social sharing
 * Updates OpenGraph and Twitter meta tags based on settings
 */
export default function DynamicMeta() {
  const { settings } = useSiteSettings();
  const { language } = useLanguage();
  
  useEffect(() => {
    if (!settings) return;
    
    const isEnglish = language === 'en';
    
    // Get share texts based on language
    const shareTitle = isEnglish 
      ? (settings.share_title_en || settings.share_title || settings.site_name || 'Tim Automobile')
      : (settings.share_title || settings.site_name || 'Tim Automobile');
      
    const shareDescription = isEnglish
      ? (settings.share_description_en || settings.share_description || 'Your partner for exclusive premium vehicles.')
      : (settings.share_description || 'Ihr Partner für exklusive Premium-Fahrzeuge.');
    
    // Get logo URL for og:image
    const logoUrl = settings.logo_url 
      ? `${window.location.origin}${settings.logo_url}`
      : '';
    
    // Update document title
    document.title = shareTitle;
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', shareDescription);
    }
    
    // Update OpenGraph tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', shareTitle);
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) ogDescription.setAttribute('content', shareDescription);
    
    const ogImage = document.querySelector('meta[property="og:image"]');
    if (ogImage && logoUrl) ogImage.setAttribute('content', logoUrl);
    
    // Update Twitter tags
    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) twitterTitle.setAttribute('content', shareTitle);
    
    const twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (twitterDescription) twitterDescription.setAttribute('content', shareDescription);
    
  }, [settings, language]);
  
  return null; // This component doesn't render anything
}
